<template>
  <div class="tours">
    <tour v-for="tour in initTours" :key="tour.id" :tour="tour"></tour>
  </div>
</template>

<script>
import CollapsibleBox from '../Shared/CollapsibleBox';
import Tour from './Tour';

export default {
  components: { CollapsibleBox, Tour },
  props: {
    initTours: {
      type: Array,
      required: true
    }
  }
};
</script>
